/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerfont1Inputs */

const en_flyerfont1 = /** @type {(inputs: Flyerfont1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typeface`)
};

const de_flyerfont1 = /** @type {(inputs: Flyerfont1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftart`)
};

/**
* | output |
* | --- |
* | "Typeface" |
*
* @param {Flyerfont1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerfont1 = /** @type {((inputs?: Flyerfont1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerfont1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerfont1(inputs)
	return de_flyerfont1(inputs)
});
export { flyerfont1 as "flyerFont" }